// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.clients {
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  overflow-x: scroll;
  flex-direction: row;
  text-align: center;
}

.clientBox p {
  overflow: hidden;
  white-space: nowrap;
}

.client-container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 5rem;
  margin: 2%;
  position: relative;
}

.clientBox {
  position: relative;
  width: 3.5rem;
  height: 3.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
}

.icon-overlay {
  position: absolute;
  top: 2px;
  right: -5px;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
}

.selectedLine {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: #f5f5f5;
  border-radius: 10px;
  padding: 10px;
  margin: 1%;
}

.icon-overlayDel {
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
}

ion-searchbar {
  --box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  --border-radius: 15px ;
}

ion-content {
  --ion-background-color: white !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/Coach/client/list-client-selectable/list-client-selectable.component.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;AACJ;;AAKE;EACE,gBAAA;EACA,mBAAA;AAFJ;;AAKE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;AAFJ;;AAKE;EACE,kBAAA;EACA,aAAA;EACA,cAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AAFJ;;AAKE;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,sCAAA;AAFJ;;AAKE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,UAAA;AAFJ;;AAKE;EACE,aAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,sCAAA;AAFJ;;AAME;EACE,6CAAA;EACA,sBAAA;AAHJ;;AAME;EACE,wCAAA;AAHJ","sourcesContent":[".clients {\r\n    width: 100%;\r\n    display: flex;\r\n    flex-wrap: nowrap;\r\n    overflow-x: scroll;\r\n    flex-direction: row;\r\n    text-align: center;\r\n\r\n  }\r\n  \r\n  \r\n  \r\n  .clientBox p {\r\n    overflow: hidden;\r\n    white-space: nowrap;\r\n  }\r\n\r\n  .client-container {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    flex-direction: column;\r\n    width: 5rem;\r\n    margin: 2%;\r\n    position: relative;\r\n  }\r\n\r\n  .clientBox {\r\n    position: relative;\r\n    width: 3.5rem;\r\n    height: 3.5rem;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    border-radius: 50%;\r\n  }\r\n\r\n  .icon-overlay {\r\n    position: absolute;\r\n    top: 2px;\r\n    right: -5px;\r\n    width: 1.5rem;\r\n    height: 1.5rem;\r\n    border-radius: 50%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    cursor: pointer;\r\n    box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);\r\n  }\r\n\r\n  .selectedLine{\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    background-color: #f5f5f5;\r\n    border-radius: 10px;\r\n    padding: 10px;\r\n    margin: 1%;\r\n  }\r\n\r\n  .icon-overlayDel{\r\n    width: 1.5rem;\r\n    height: 1.5rem;\r\n    border-radius: 50%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    cursor: pointer;\r\n    box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);\r\n  }\r\n\r\n  \r\n  ion-searchbar{\r\n    --box-shadow:  rgba(0, 0, 0, 0.24) 0px 3px 8px;\r\n    --border-radius : 15px\r\n  }\r\n\r\n  ion-content{\r\n    --ion-background-color: white !important; \r\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
